<template>
  <div v-if="billings">
    <h1 style="margin: 0 0 4px">Billing</h1>
    <div class="row">
      <!--      <div class="col-sm-10">-->
      <!--        <div class="row">-->
      <!--          v2-->
      <!--          <div class="col-sm-2">-->
      <!--            <button class="bigBtn blackBtn">Sales List</button>-->
      <!--          </div>-->
      <!--          <div class="col-sm-2">-->
      <!--            <button class="bigBtn">Subscriptions</button>-->
      <!--          </div>-->
      <div class="col-sm-12 flexRow justify-content-end mb-2">
        <div class="row">
          <div class="col-sm-3 textCenter">
            <input
              class="search-input"
              v-model="search"
              placeholder="Search"
              @input="filterBillings"
            />
          </div>
          <div class="col-sm-3">
            <hilo-select
              v-model="filterByBillingStatus"
              :options="billingStatuses"
              placeholder="Select Status"
              @change="filterBillings"
              :customStyle="{
                height: '40px',
                backgroundColor: '#ececec',
              }"
            >
            </hilo-select>
          </div>
          <!--              v2-->
          <!--              <div class="col-sm-3 textCenter">-->
          <!--                <el-date-picker-->
          <!--                  v-model="searchDateRange"-->
          <!--                  type="datetimerange"-->
          <!--                  range-separator="-"-->
          <!--                  start-placeholder="Start date"-->
          <!--                  end-placeholder="End date"-->
          <!--                  @change="filterBillings"-->
          <!--                  :format="'yyyy-MM-dd hh:mm a'"-->
          <!--                ></el-date-picker>-->
          <!--              </div>-->
        </div>
      </div>
      <!--        </div>-->
      <!--      </div>-->
      <!--      v2-->
      <!--      <div class="col-sm-2">-->
      <!--        <div class="row">-->
      <!--          <div class="col-sm-6">-->
      <!--            <hilo-button label="Print" @click="printBillings" />-->
      <!--          </div>-->
      <!--          <div class="col-sm-6">-->
      <!--            <hilo-button-->
      <!--              class="blackBtn"-->
      <!--              label="Export"-->
      <!--              @click="exportBillings"-->
      <!--            />-->
      <!--          </div>-->
      <!--          <div class="col-sm-12 flexRow textCenter">-->
      <!--            Date Range: {{ getDateRange() }}-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <hilo-table :columns="columns" :data="filteredBillings" />
    <coming-soon-modal />
  </div>
</template>
<script>
import { Button, Input, DatePicker } from "element-ui";
import HiloTable from "src/components/HiloComponents/HiloTable.vue";
import dayjs from "dayjs";
import BillingAPIService from "src/servicehandlers/BillingAPIService";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import { useLoginStore } from "@/stores/loginStore";
import ComingSoonModal from '@/components/HiloComponents/ComingSoonModal.vue';
const billingAPIService = new BillingAPIService();

export default {
  name: "Billings",
  components: {
    ComingSoonModal,
    HiloSelect,
    HiloTable,
    [Button.name]: Button,
    [Input.name]: Input,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      billings: [],
      filteredBillings: [],
      search: "",
      billingStatuses: [],
      columns: [
        {
          key: "date",
          label: "Date Time",
        },
        {
          key: "referenceNumber",
          label: "Ref Num",
        },
        {
          key: "view",
          label: "View Invoice",
          component: "HiloButton",
          componentProps: () => ({
            onClick: () => this.sendInvoice(scope.row),
            label: "View",
          }),
        },
        {
          key: "customer",
          label: "Customer",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "total",
          label: "Total",
        },
        {
          key: "due",
          label: "Amount Due",
        },
        {
          key: "actions",
          label: "Actions",
          component: "HiloButton",
          componentProps: (row) => ({
            label:
              row.status === "Paid"
                ? "Send Receipt"
                : row.status === "Billed"
                  ? "Sent"
                  : "Send Invoice",
            onClick: () => this.sendInvoice(scope.row),
          }),
        },
      ],
      filterByBillingStatus: null,
      // searchDateRange: [],
    };
  },
  async mounted() {
    await this.getBillings();
    await this.getBillingLists();
  },
  methods: {
    async getBillings() {
      try {
        let response;
        if (useLoginStore().isAdmin) {
          response = await billingAPIService.get();
        } else {
          response = await billingAPIService.getByUserId(useLoginStore().getUser.id);
        }
        this.billings = response.map((item) => ({
          id: item.id,
          date: dayjs(item.date).format("MM/DD/YY, hh:mm A"),
          referenceNumber: item.referenceNumber,
          customer: `${item.activeStudent.user.firstName} ${item.activeStudent.user.lastName}`,
          status: item.billingStatus.name,
          total: this.formatDollars(item.total),
          due:
            item.billingStatus.name === "Paid"
              ? this.formatDollars(0)
              : this.formatDollars(item.total),
        }));
        this.filteredBillings = this.billings;
      } catch (error) {}
    },
    async getBillingLists() {
      this.billingStatuses = await billingAPIService.getBillingStatuses();
      await billingAPIService.getBillingTypes();
      await billingAPIService.getBillingItemTypes();
    },
    // printBillings() {
    //   alert("Print");
    // },
    // exportBillings() {
    //   alert("Export");
    // },
    // getDateRange() {
    //   let firstDate, lastDate;
    //
    //   if (this.searchDateRange && this.searchDateRange.length !== 0) {
    //     firstDate = this.searchDateRange[0];
    //     lastDate = this.searchDateRange[1];
    //   } else {
    //     for (let billing of this.billings) {
    //       if (this.billings.indexOf(billing) === 0) {
    //         firstDate = billing.date;
    //         lastDate = billing.date;
    //       } else {
    //         if (billing.date > lastDate) {
    //           lastDate = billing.date;
    //         }
    //         if (billing.date < firstDate) {
    //           firstDate = billing.date;
    //         }
    //       }
    //     }
    //   }
    //
    //   return (
    //     firstDate.toLocaleDateString() + " - " + lastDate.toLocaleDateString()
    //   );
    // },
    filterBillings() {
      const statusString = this.billingStatuses.find(
        (status) => status.id === this.filterByBillingStatus,
      )?.name;

      const searchTerm = this.search.toLowerCase();
      const columnKeys = this.columns.map((column) => column.key);
      this.filteredBillings = this.billings
        .filter((bill) => {
          return columnKeys.some((key) => {
            const value = bill[key];
            return value && value.toString().toLowerCase().includes(searchTerm);
          });
        })
        .filter((data) => !statusString || data.status === statusString);
      // .filter(
      //   (data) =>
      //     !this.searchDateRange ||
      //     this.searchDateRange.length <= 0 ||
      //     (data.date >= this.searchDateRange[0] &&
      //       data.date <= this.searchDateRange[1]),
      // );
      this.getBillingData(this.filteredBillings);
    },
    // viewBillings(row) {
    //   alert("View " + row.referenceNumber + " billing");
    // },
    formatDollars(num) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
    },
    sendReceipt(row) {
      alert("Sent receipt for billing " + row.referenceNumber);
    },
    sendInvoice(row) {
      alert("Sent Invoice for billing " + row.referenceNumber);
    },
  },
};
</script>
<style scoped>
h4 {
  margin: 0;
}
p {
  font-size: 16px;
  padding: 1em 1em;
}
td,
tr {
  padding: 0;
  margin: 0;
  border: none;
}
button {
  padding: 5px;
  border: 1px solid black;
  color: black;
  border-radius: 6px;
  width: 100%;
}
button:hover {
  color: #00bbff;
  border-color: #00bbff;
  background-color: white;
}
.flexRow {
  margin-top: 10px;
}
.textCenter {
  text-align: center;
  justify-content: center;
}
input {
  border: 1px #dedfdf solid;
  border-radius: 5px;
  height: 100%;
  width: 100%;
  padding: 0 10px;
}
/*.bigBtn {
  font-size: 20px;
  width: 100%;
  border-radius: 3em;
}
.blackBtn {
  border-color: black;
  background-color: black;
  color: white;
}*/
</style>
